import { Component, computed, input, output } from '@angular/core';
import { addDays, addMonths, addWeeks, addYears } from 'date-fns';
import { ChartComponent, Button, LoadingSpinner, Alert } from 'excellence-ui';
import {
  ConsumptionFilter,
  getSelectedFrom,
  getSelectedTo,
  LoadCurveState,
} from '../../stores/consumption.store';
import { NgIcon } from '@ng-icons/core';
import { DatePipe } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { ErrorComponent } from '../../../../shared/components/error-component/error-component';
import { AnalysisConsumptionChartOptionsPipe } from '../../pipes/analysis-consumption-chart-options-pipe';
import { ConsumptionGraphConfigOptions } from '../../chart-config/consumption/util';
import { GermanNumberPipe } from '../../../../shared/pipes/german-number-pipe';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-analysis-consumption-graph-card',
  imports: [
    ChartComponent,
    Button,
    NgIcon,
    DatePipe,
    ErrorComponent,
    LoadingSpinner,
    AnalysisConsumptionChartOptionsPipe,
    TranslocoPipe,
    GermanNumberPipe,
    DatePipe,
    Alert,
    RouterLink,
  ],
  templateUrl: './analysis-consumption-graph-card.html',
})
export class AnalysisConsumptionGraphCard {
  organizationId = input.required<string>();

  filter = input.required<ConsumptionFilter>();
  state = input.required<LoadCurveState | null>();

  changeGranularity = output<ConsumptionFilter['granularity']>();
  changeDate = output<Date>();
  clickReload = output();

  protected selectedFrom = computed(() => getSelectedFrom(this.filter()));
  protected selectedTo = computed(() => getSelectedTo(this.filter()));

  protected view = computed(() => this.filter().view);

  protected showPlaceholder = computed(() => {
    const data = this.state()?.data;
    if (!data) {
      return true;
    }
    return data.loadCurveStatus !== 'IN_SYNC' || data.data.length === 0;
  });

  protected graphOptions = computed<ConsumptionGraphConfigOptions>(() => {
    const filter = this.filter();
    return {
      view: filter.view,
      utilityType: filter.data.utilityType,
      granularity: filter.granularity,
      placeholder: this.showPlaceholder(),
    };
  });

  protected onClickNextButton() {
    const selectedDate = this.filter().date;
    switch (this.filter().granularity) {
      case 'YEAR': {
        this.changeDate.emit(addYears(selectedDate, 1));
        break;
      }
      case 'MONTH': {
        this.changeDate.emit(addMonths(selectedDate, 1));
        break;
      }
      case 'WEEK': {
        this.changeDate.emit(addWeeks(selectedDate, 1));
        break;
      }
      case 'DAY': {
        this.changeDate.emit(addDays(selectedDate, 1));
        break;
      }
    }
  }

  protected onClickPreviousButton() {
    const selectedDate = this.filter().date;
    switch (this.filter().granularity) {
      case 'YEAR': {
        this.changeDate.emit(addYears(selectedDate, -1));
        break;
      }
      case 'MONTH': {
        this.changeDate.emit(addMonths(selectedDate, -1));
        break;
      }
      case 'WEEK': {
        this.changeDate.emit(addWeeks(selectedDate, -1));
        break;
      }
      case 'DAY': {
        this.changeDate.emit(addDays(selectedDate, -1));
        break;
      }
    }
  }

  protected onClickTodayButton() {
    this.changeDate.emit(new Date());
  }
}
